import React from 'react'
import ReactPlayer from 'react-player'
export const VideoPlayer = ({ url, className = '' }) => {
    return (
        <ReactPlayer url={url} className={className} controls={true}/>
    )
}